// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loading_loaderContainer__dgxZh","loader":"Loading_loader__5x8I1","slide":"Loading_slide__QI35z","rotate":"Loading_rotate__N4NKF"};